/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class LineOaFinancierWebhookControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any OK
     * @throws ApiError
     */
    public handleWebhook3({
        financierId,
        secret,
        requestBody,
    }: {
        financierId: string,
        secret: string,
        requestBody: string,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/public/v2/financiers/{financierId}/line-oa/webhook',
            path: {
                'financierId': financierId,
            },
            query: {
                'secret': secret,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
